<template lang="pug">
div
  .row.form-group
    .col-sm-12
      p.m-t-md._500 Price Adjustment
    .col-sm-12.form-group
      .col-sm-4
        label.md-check
          input(type="radio" name="price_adjustment_mode" value="none" v-model="entry.price_adjustment_mode")
          i.indigo
          | No change
      .col-sm-4
        label.md-check
          input(type="radio" name="price_adjustment_mode" value="amount" v-model="entry.price_adjustment_mode")
          i.indigo
          | By amount
      .col-sm-4
        label.md-check
          input(type="radio" name="price_adjustment_mode" value="percent" v-model="entry.price_adjustment_mode")
          i.indigo
          | By percentage
    .col-sm-12
      .row.form-group
        label.col-form-label.col-sm-2 Amount
        .col-sm-10
          input(
            v-model="entry.price"
            type="number"
            class="form-control"
            name="price"
            placeholder="0"
            :disabled="entry.price_adjustment_mode === 'none'"
          )
          span(
            v-show="errors.has('price')"
            class="form-error-msg"
          )
            | {{ errors.first('price') }}

</template>
<script>
export default {
    props: {
        onChange: {
            required: true,
            type: Function,
        },
    },
    data: function() {
        return {
            entry: {
                price_adjustment_mode: 'none',
                price: '0',
            },
        };
    },

    watch: {
        entry: {
            handler: function(newEntry) {
                this.onChange(newEntry);
            },
            deep: true,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch/override-values-form.vue